// 📁 MyShopInventory.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Chip,
  Snackbar,
  Alert,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BarChartIcon from "@mui/icons-material/BarChart";
import SettingsIcon from "@mui/icons-material/Settings";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Grocerylogo from "../../images/Grocerylogo.png";
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
const drawerWidth = 240;

function MyShopInventory() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [myInventory, setMyInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editingProduct, setEditingProduct] = useState(null);
  const [newMrp, setNewMrp] = useState("");
  const [newUom, setNewUom] = useState(""); // 🔹 yeh add karo
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newProduct, setNewProduct] = useState({
    barcode: "",
    productName: "",
    group: "",
    subCategory: "",
    uom: "",
    mrp: "",
    hsnCode: "",
  });

  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const buttons = [
    { label: "Dashboard", icon: <DashboardIcon /> },
    { label: "Inventory", icon: <InventoryIcon /> },
    { label: "Orders", icon: <ShoppingCartIcon /> },
    { label: "Reports", icon: <BarChartIcon /> },
    { label: "Settings", icon: <SettingsIcon /> },
  ];
  const groupOptions = [
    "Shetkari maal-tarkari - शेतकरी माल-तरकारी",
    "Snacks - नाश्ता",
    "Drinks, Beverages - पेये",
    "Shetkari mal",
    "Drinks",
    "Vegetables",
  ];

  const subCategoryOptions = [
    "Bhajipala - भाजीपाला",
    "Fruits - फळे",
    "Noodle, Pasta - नूडल्स, पास्ता",
    "Soft Drinks - शीतपेये",
    "Bhajipala",
    "Softdrinks",
    "Pet Vegetables",
  ];
  useEffect(() => {
    const shopkeeperId = localStorage.getItem("shopkeeperID");
    if (!shopkeeperId)
      return alert("Missing Shopkeeper ID. Please log in again.");
    fetchMyInventory(shopkeeperId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredInventory(
      myInventory.filter((item) =>
        item.productName?.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    );
  }, [searchQuery, myInventory]);

  const handleEditClick = (product) => {
    setEditingProduct(product);
    setNewMrp(product.customPrice || product.mrp || "");
    setNewUom(product.customUom || product.uom || "");
    setEditDialogOpen(true);
  };

  const fetchMyInventory = async (shopkeeperId) => {
    try {
      const response = await axios.get(
        `https://sakhisshop.com/api/shopkeeper/${shopkeeperId}/inventory`,
      );

      const inventoryList = (response.data.inventory || []).map((item) => ({
        inventoryId: item.inventoryId,
        productId: item.productId,
        productName: item.productName,
        barcode: item.barcode,
        group: item.group,
        subCategory: item.subCategory,
        uom: item.customUom || item.uom, // ✅ yahan fix
        hsnCode: item.hsnCode,
        // server uses inStock boolean; we want isOutOfStock boolean for UI
        isOutOfStock: item.inStock === false,
        customPrice: item.customPrice ?? item.mrp,
        isCustomProduct: !!item.isCustomProduct,
        type: item.isCustomProduct ? "custom" : "default",
      }));

      const customList = (response.data.customProducts || []).map((item) => ({
        inventoryId: item.inventoryId ?? item.id ?? Math.random(),
        productId: item.id ?? null,
        productName: item.productName,
        barcode: item.barcode,
        group: item.group,
        subCategory: item.subCategory,
        uom: item.customUom || item.uom, // ✅ yahan fix
        hsnCode: item.hsnCode,
        isOutOfStock: item.inStock === false,
        customPrice: item.customPrice ?? item.mrp,
        isCustomProduct: true,
        type: "custom",
      }));

      // Merge + dedupe by inventoryId (inventoryId is best unique key)
      const all = [...inventoryList, ...customList];
      const uniqueMap = new Map();
      all.forEach((it) => {
        const key =
          it.inventoryId ?? it.productId ?? it.barcode ?? Math.random();
        if (!uniqueMap.has(key)) uniqueMap.set(key, it);
      });
      const allItems = Array.from(uniqueMap.values());

      setMyInventory(allItems);
      setFilteredInventory(
        allItems.filter((item) =>
          item.productName?.toLowerCase().includes(searchQuery.toLowerCase()),
        ),
      );
    } catch (error) {
      console.error("❌ Failed to fetch inventory.", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to fetch inventory.",
        severity: "error",
      });
    }
  }; // <-- end fetchMyInventory

  // const handlePriceUpdate = async () => {
  //   try {
  //     const shopkeeperId = localStorage.getItem("shopkeeperID");

  //     if (editingProduct.type === "default") {
  //       await axios.put(
  //         `https://sakhisshop.com/api/inventory/price?shopkeeperId=${shopkeeperId}&productId=${editingProduct.productId}`,
  //         { newPrice: parseFloat(newMrp) }
  //       );
  //     } else if (editingProduct.type === "custom") {
  //       // use inventoryId for custom products
  //       await axios.put(
  //         `https://sakhisshop.com/api/shopkeeper/custom-product/${editingProduct.inventoryId}/price`,
  //         { newPrice: parseFloat(newMrp) }
  //       );
  //     }

  //     setSnackbar({
  //       open: true,
  //       message: "✅ Price updated successfully",
  //       severity: "success",
  //     });

  //     setEditDialogOpen(false);
  //     fetchMyInventory(localStorage.getItem("shopkeeperID"));
  //   } catch (error) {
  //     console.error("❌ Failed to update price", error);
  //     setSnackbar({
  //       open: true,
  //       message: "❌ Failed to update price",
  //       severity: "error",
  //     });
  //   }
  // };
  // const handlePriceUpdate = async () => {
  //   try {
  //     const shopkeeperId = localStorage.getItem("shopkeeperID");
  //     const productId = editingProduct.productId; // Must exist for both default & custom

  //     const parsedPrice = parseFloat(newMrp);

  //     // ✅ Optimistic UI update
  //     setMyInventory((prev) =>
  //       prev.map((item) =>
  //         item.inventoryId === editingProduct.inventoryId || item.productId === productId
  //           ? { ...item, mrp: parsedPrice }
  //           : item
  //       )
  //     );

  //     // 🔹 Single endpoint for both types
  //     await axios.put(
  //       `https://sakhisshop.com/api/inventory/price?shopkeeperId=${shopkeeperId}&productId=${productId}`,
  //       { newPrice: parsedPrice }
  //     );

  //     setSnackbar({
  //       open: true,
  //       message: "✅ Price updated successfully",
  //       severity: "success",
  //     });

  //     setEditDialogOpen(false);

  //     // 🔄 Refresh inventory from backend to get the latest data
  //     fetchMyInventory(shopkeeperId);

  //   } catch (error) {
  //     console.error("❌ Failed to update price", error);

  //     // Rollback optimistic UI update in case of error
  //     fetchMyInventory(localStorage.getItem("shopkeeperID"));

  //     setSnackbar({
  //       open: true,
  //       message: "❌ Failed to update price",
  //       severity: "error",
  //     });
  //   }
  // };

  // const handleUpdateProduct = async () => {
  //   try {
  //     const shopkeeperId = localStorage.getItem("shopkeeperID");
  //     const productId = editingProduct.productId;

  //     const parsedPrice = newMrp ? parseFloat(newMrp) : null;

  //     // ✅ Optimistic UI update
  //     setMyInventory((prev) =>
  //       prev.map((item) =>
  //         item.inventoryId === editingProduct.inventoryId || item.productId === productId
  //           ? { ...item, mrp: parsedPrice ?? item.mrp, uom: newUom || item.uom }
  //           : item
  //       )
  //     );

  //     // ✅ Single API call for both custom & regular
  //     await axios.put(
  //       `https://sakhisshop.com/api/inventory/update?shopkeeperId=${shopkeeperId}&productId=${productId}`,
  //       {
  //         newPrice: parsedPrice,
  //         newUom: newUom,
  //         newUom: newUom || editingProduct.uom, // fallback to old UOM if not changed

  //       }
  //     );

  //     setSnackbar({
  //       open: true,
  //       message: "✅ Product details updated successfully",
  //       severity: "success",
  //     });

  //     setEditDialogOpen(false);
  //     fetchMyInventory(shopkeeperId);
  //   } catch (error) {
  //     console.error("❌ Failed to update product details", error);
  //     fetchMyInventory(localStorage.getItem("shopkeeperID"));
  //     setSnackbar({
  //       open: true,
  //       message: "❌ Failed to update product details",
  //       severity: "error",
  //     });
  //   }
  // };

  const handleUpdateProduct = async () => {
    const shopkeeperId = localStorage.getItem("shopkeeperID");

    try {
      if (editingProduct.type === "default") {
        // Regular product update
        if (!editingProduct.productId)
          return console.error("❌ productId missing");

        await axios.put(
          `/api/inventory/update?shopkeeperId=${shopkeeperId}&productId=${editingProduct.productId}`,
          {
            newPrice: parseFloat(newMrp),
            newUom: newUom || editingProduct.uom,
          },
        );

        // ✅ Optimistic UI update for DEFAULT
        setMyInventory((prev) =>
          prev.map((item) =>
            item.productId === editingProduct.productId
              ? {
                  ...item,
                  customPrice: parseFloat(newMrp) || item.customPrice,
                  customUom: newUom || item.customUom, // 🔥 yaha bhi customUom update karo
                }
              : item,
          ),
        );
      } else if (editingProduct.type === "custom") {
        // Custom product update
        if (!editingProduct.inventoryId)
          return console.error("❌ inventoryId missing");

        await axios.put(
          `/api/shopkeeper/custom-product/${editingProduct.inventoryId}/price`,
          {
            newPrice: parseFloat(newMrp),
            newUom: newUom || editingProduct.uom,
          },
        );

        // ✅ Optimistic UI update for CUSTOM
        setMyInventory((prev) =>
          prev.map((item) =>
            item.inventoryId === editingProduct.inventoryId
              ? {
                  ...item,
                  customPrice: parseFloat(newMrp) || item.customPrice,
                  customUom: newUom || item.customUom, // 🔥 custom ka UOM update yaha
                }
              : item,
          ),
        );
      }

      setSnackbar({
        open: true,
        message: "✅ Product updated successfully",
        severity: "success",
      });

      setEditDialogOpen(false);

      // Refresh from backend
      fetchMyInventory(shopkeeperId);
    } catch (error) {
      console.error("❌ Failed to update product", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to update product",
        severity: "error",
      });
    }
  };

  const handleAddProduct = async () => {
    try {
      const shopkeeperId = localStorage.getItem("shopkeeperID");

      const payload = {
        ...newProduct,
        type: "custom",
        mrp: parseFloat(newProduct.mrp),
        uom: newUom || newProduct.uom, // ✅ fix here
        shopkeeperId: parseInt(shopkeeperId),
      };

      await axios.post(
        "https://sakhisshop.com/api/shopkeeper/custom-product",
        payload,
      );

      // ✅ UI turant update karo (optimistic update)
      setMyInventory((prev) => [
        ...prev,
        {
          ...payload,
          inventoryId: Date.now(), // temp ID (backend se refresh hone tak)
          isCustomProduct: true,
          type: "custom",
        },
      ]);

      setSnackbar({
        open: true,
        message: "✅ Product Added successfully",
        severity: "success",
      });
      setAddDialogOpen(false);
      setNewProduct({
        barcode: "",
        productName: "",
        group: "",
        subCategory: "",
        uom: "",
        mrp: "",
        hsnCode: "",
      });

      fetchMyInventory(shopkeeperId); // 🔄 Refresh list
    } catch (error) {
      console.error("❌ Failed to add product", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to add product. Try again",
        severity: "error",
      });
    }
  };

  // delete and OutOfStock
  const handleDeleteProduct = async (inventoryId) => {
    try {
      await axios.delete(
        `https://sakhisshop.com/api/shopkeeper/inventory/${inventoryId}`,
      );
      setSnackbar({
        open: true,
        message: "🗑 Product deleted!",
        severity: "success",
      });
      fetchMyInventory(localStorage.getItem("shopkeeperID")); // ✅ Refresh after delete
    } catch (error) {
      console.error("❌ Delete failed", error);
      setSnackbar({
        open: true,
        message: "❌ Delete failed",
        severity: "error",
      });
    }
  };

  const handleDeleteAll = async () => {
    const shopkeeperId = localStorage.getItem("shopkeeperID"); // ✅ Yahi missing tha

    if (!shopkeeperId || shopkeeperId === "null") {
      alert("❌ Error: Shopkeeper ID missing. Please login again.");
      return;
    }

    try {
      await axios.delete(
        `https://sakhisshop.com/api/shops/delete-uploaded?shopkeeperId=${shopkeeperId}`,
      );

      alert("All uploaded products deleted!");

      // 🔄 Fetch inventory again
      fetchMyInventory(shopkeeperId);
    } catch (error) {
      console.error(error);
      alert("Error while deleting");
    }
  };
  const handleOutOfStock = async (inventoryId) => {
    try {
      await axios.put(
        `https://sakhisshop.com/api/shopkeeper/inventory/${inventoryId}/out-of-stock`,
      );
      setSnackbar({
        open: true,
        message: "🚫 Marked as out of stock",
        severity: "info",
      });

      // ✅ Mark as OUT OF STOCK locally
      setFilteredInventory((prevInventory) =>
        prevInventory.map((product) =>
          product.inventoryId === inventoryId
            ? { ...product, isOutOfStock: true }
            : product,
        ),
      );
    } catch (error) {
      console.error("❌ OutOfStock failed", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to update stock",
        severity: "error",
      });
    }
  };

  const handleBackInStock = async (inventoryId) => {
    try {
      await axios.put(
        `https://sakhisshop.com/api/shopkeeper/inventory/${inventoryId}/in-stock`,
      );
      setSnackbar({
        open: true,
        message: "✅ Marked as in stock",
        severity: "success",
      });

      // ✅ Mark as IN STOCK locally
      setFilteredInventory((prevInventory) =>
        prevInventory.map((product) =>
          product.inventoryId === inventoryId
            ? { ...product, isOutOfStock: false }
            : product,
        ),
      );
    } catch (error) {
      console.error("❌ In Stock failed", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to mark in stock",
        severity: "error",
      });
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <CssBaseline />
      <Header2 />

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { width: drawerWidth },
        }}
      >
        <Box onClick={() => setMobileOpen(false)} textAlign="center">
          <Box my={2}>
            <img src={Grocerylogo} alt="Logo" style={{ height: 60 }} />
          </Box>
          <Divider />
          <List>
            {buttons.map((btn, index) => (
              <ListItem button key={index}>
                <ListItemIcon>{btn.icon}</ListItemIcon>
                <ListItemText primary={btn.label} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
        <Toolbar />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <IconButton onClick={() => navigate(-1)} color="warning">
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              fontFamily: "Segoe UI",
              color: "#1b5e20",
              alignItems: "center",
            }}
          >
            🛒 My Shop Inventory
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="error"
          onClick={handleDeleteAll}
          style={{ marginBottom: "10px" }}
        >
          Delete All Products
        </Button>
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          alignItems="center"
          mb={2}
          gap={2}
        >
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search Product..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
            sx={{ flex: 1, minWidth: "200px" }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setAddDialogOpen(true)}
          >
            Add New Item
          </Button>
        </Box>

        <Box display="flex" justifyContent="center" sx={{ overflowX: "auto" }}>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              maxWidth: "1200px",
              borderRadius: 3,
              boxShadow: "0px 5px 20px rgba(0,0,0,0.1)",
            }}
          >
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#1976D2" }}>
                <TableRow>
                  {[
                    "ID",
                    "Barcode",
                    "Product Name",
                    "Group",
                    "Sub Category",
                    "UOM",
                    "MRP",
                    "HSN Code",
                    "Actions",
                  ].map((h, i) => (
                    <TableCell
                      key={i}
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredInventory
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((product) => (
                    <TableRow
                      key={product.inventoryId}
                      hover
                      sx={
                        product.isOutOfStock
                          ? { backgroundColor: "#ffe0e0", opacity: 0.5 }
                          : product.type === "custom"
                            ? { backgroundColor: "#e3f2fd" }
                            : {}
                      }
                    >
                      {/* ID */}
                      <TableCell>{product.inventoryId}</TableCell>

                      {/* Barcode */}
                      <TableCell>{product.barcode}</TableCell>

                      {/* Product Name */}
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {product.productName}
                        </Typography>
                      </TableCell>

                      {/* Group */}
                      <TableCell>{product.group}</TableCell>

                      {/* Sub Category */}
                      <TableCell>{product.subCategory}</TableCell>

                      {/* UOM */}
                      <TableCell>{product.customUom || product.uom}</TableCell>

                      {/* MRP */}
                      <TableCell>
                        {product.customPrice || product.mrp}
                      </TableCell>

                      {/* HSN Code */}
                      <TableCell>{product.hsnCode}</TableCell>

                      {/* Actions (COMMENTED OUT) */}

                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditingProduct(product);
                            setNewMrp(product.customPrice || product.mrp);
                            setNewUom(product.customUom || product.uom);
                            setEditDialogOpen(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDeleteProduct(product.inventoryId)
                          }
                        >
                          🗑
                        </IconButton>

                        <Button
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleOutOfStock(product.inventoryId)}
                        >
                          Out of Stock
                        </Button>

                        {!product.isOutOfStock ? (
                          <Chip
                            label="✅ In Stock"
                            color="success"
                            size="small"
                          />
                        ) : (
                          <Button
                            variant="outlined"
                            color="success"
                            size="small"
                            onClick={() =>
                              handleBackInStock(product.inventoryId)
                            }
                          >
                            In Stock
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredInventory.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
                setPage(0);
              }}
              sx={{ px: 2 }}
            />
          </TableContainer>
        </Box>

        {/* Edit Product Dialog */}
        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
          <DialogTitle>Update Product</DialogTitle>
          <DialogContent>
            {[
              "barcode",
              "productName",
              "group",
              "subCategory",
              "mrp",
              "hsnCode",
            ].map((field, i) => (
              <TextField
                key={i}
                label={field.charAt(0).toUpperCase() + field.slice(1)}
                fullWidth
                sx={{ mt: 2 }}
                value={newProduct[field]}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, [field]: e.target.value })
                }
              />
            ))}
            {/* Group Dropdown */}
            <TextField
              select
              label="Group"
              fullWidth
              sx={{ mt: 2 }}
              value={newProduct.group}
              onChange={(e) =>
                setNewProduct({ ...newProduct, group: e.target.value })
              }
            >
              {groupOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            {/* SubCategory Dropdown */}
            <TextField
              select
              label="SubCategory"
              fullWidth
              sx={{ mt: 2 }}
              value={newProduct.subCategory}
              onChange={(e) =>
                setNewProduct({ ...newProduct, subCategory: e.target.value })
              }
            >
              {subCategoryOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {/* 🔹 UOM as disabled TextField (not editable) */}
            <TextField
              label="UOM"
              fullWidth
              sx={{ mt: 2 }}
              value={editingProduct?.customUom || editingProduct?.uom || ""}
              disabled
            />

            {/* Editable Price */}
            <TextField
              label="New MRP (₹)"
              type="number"
              fullWidth
              value={newMrp}
              onChange={(e) => setNewMrp(e.target.value)}
              sx={{ mt: 2 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleUpdateProduct}
              disabled={!newMrp || isNaN(newMrp)}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add New Product Dialog */}
        <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)}>
          <DialogTitle>Add New Product</DialogTitle>
          <DialogContent>
            {["barcode", "productName", "mrp", "hsnCode"].map((field, i) => (
              <TextField
                key={i}
                label={field.charAt(0).toUpperCase() + field.slice(1)}
                fullWidth
                sx={{ mt: 2 }}
                value={newProduct[field]}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, [field]: e.target.value })
                }
              />
            ))}
            {/* Group Dropdown */}
            <TextField
              select
              label="Group"
              fullWidth
              sx={{ mt: 2 }}
              value={newProduct.group}
              onChange={(e) =>
                setNewProduct({ ...newProduct, group: e.target.value })
              }
            >
              {groupOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            {/* SubCategory Dropdown */}
            <TextField
              select
              label="SubCategory"
              fullWidth
              sx={{ mt: 2 }}
              value={newProduct.subCategory}
              onChange={(e) =>
                setNewProduct({ ...newProduct, subCategory: e.target.value })
              }
            >
              {subCategoryOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {/* 🔹 UOM Dropdown */}
            <TextField
              select
              label="UOM"
              fullWidth
              sx={{ mt: 2 }}
              value={newUom}
              onChange={(e) => setNewUom(e.target.value)}
            >
              <MenuItem value="kg">kg</MenuItem>
              <MenuItem value="g">g</MenuItem>
              <MenuItem value="ltr">ltr</MenuItem>
              <MenuItem value="ml">ml</MenuItem>
              <MenuItem value="no">no</MenuItem>
              <MenuItem value="dozen">dozen</MenuItem>
              <MenuItem value="pair">pair</MenuItem>   
            </TextField>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setAddDialogOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleAddProduct}>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}

export default MyShopInventory;
